import React, { useEffect, useState } from 'react';
import { DateSelect } from '../../../../../components/UI-Elements/Date/DateSelect';
import { ClientOrderQuote } from '../../../../../sp-types/clientOrderQuoteType';
import { MonthYear } from '../../../../../utils/MonthYear/monthYear';
import { MonthYearValue } from '../../../../../utils/MonthYear/MonthYearValue';
import { priceMockData } from './DuoDateComponents/DuoDateMockData';
import { DuoDateQuantityCalendar } from './DuoDateComponents/DuoDateQuantityCalendar';

interface Props {
  duoDate: MonthYear | undefined;
  quantity: number;
  priceCalender?: MonthYearValue[];
  updateClientOrder: <K extends keyof ClientOrderQuote>(prop: K, value: ClientOrderQuote[K]) => void;
}

export const CoQuoteDueDate: React.FC<Props> = ({ updateClientOrder, priceCalender, quantity }) => {
  const [selectedDates, setSelectedDates] = useState({ start: '11/2024', end: '8/2025' });

  const updatePriceCalendar = (data: MonthYearValue[]) => {
    updateClientOrder('priceCalendar', data);
  };

  useEffect(() => {
    // updateClientOrder('DateRange', formatDateRange(selectedDates.start, selectedDates.end));
  }, [selectedDates]);

  return (
    <div className="flex flex-col h-full  justify-between   my-[2rem] mx-[2rem] space-y-[0.75rem]   ">
      <div>
        <div className="flex text-lg">Select dates</div>
        <div className="flex space-x-4 max-w-[30rem] ">
          <DateSelect
            selectedDate={selectedDates.start}
            setSelectedDate={(value: string) => setSelectedDates({ ...selectedDates, start: value })}
            mode="monthYear"
            subTitle="From"
          />
          <DateSelect
            selectedDate={selectedDates.end}
            setSelectedDate={(value: string) => setSelectedDates({ ...selectedDates, end: value })}
            mode="monthYear"
            subTitle="To"
          />
        </div>
      </div>
      <div className=" flex flex-row pb-[5rem] ">
        <DuoDateQuantityCalendar
          priceCalendar={priceCalender}
          setPriceCalendar={updatePriceCalendar}
          duoDate={{ month: 10, year: 2024 }}
          quantity={quantity}
          pricePerTonData={priceMockData}
          singleYearView={false}
        />
      </div>
    </div>
  );
};

// const getMonthName = (monthNumber: number) => {
//   const date = new Date();
//   date.setMonth(monthNumber - 1); // monthNumber is 1-based (1 = January, 2 = February, etc.)
//   return date.toLocaleString('default', { month: 'short' }); // 'short' for abbreviated month names
// };

// const formatDateRange = (start: string, end: string): string => {
//   const [startMonth, startYear] = start.split('/');
//   const [endMonth, endYear] = end.split('/');
//   console.log(start);
//   const startMonthName = getMonthName(parseInt(startMonth, 10));
//   const endMonthName = getMonthName(parseInt(endMonth, 10));

//   return `${startMonthName} ${startYear} - ${endMonthName} ${endYear}`;
// };
